import { DatiPignoramento } from 'src/app/common/models/dati-pignoramento/dati-pignoramento';

export class DatiPignoramentoAdapter {

  static createRequest(request: DatiPignoramento): DatiPignoramento {
    let clonedRequest: DatiPignoramento = new DatiPignoramento();
    if (request && request.id) {
      clonedRequest.id = request.id;
    }
    clonedRequest.terzo = request.terzo;

    if (request.importoPrecettato) {
      clonedRequest.importoPrecettato = request.importoPrecettato.toString().trim().replace('.', ',');
    }

    if (request.pignorato) {
      clonedRequest.pignorato = request.pignorato;
      if (request.sommaPignorata) {
        clonedRequest.sommaPignorata = request.sommaPignorata.toString().trim().replace('.', ',');
      }
    }

    clonedRequest.cf = request.cf;
    clonedRequest.sede = request.sede;
    clonedRequest.pec = request.pec;
    clonedRequest.note = request.note;

    return clonedRequest;
  }



}
